export const APP_AUTH_BASE_URL = process.env.REACT_APP_APP_API_BASE_URL;
export const APP_AUTH_URL = process.env.REACT_APP_APP_AUTH_URL;

// Dev: empty base → axios uses relative URLs that the CRA dev proxy
// (src/setupProxy.js) forwards to the backend gateway, avoiding browser CORS.
// Production build keeps the real host from the env var (unchanged behaviour).
export const baseUrl =
  process.env.NODE_ENV === "development"
    ? ""
    : process.env.REACT_APP_APP_API_BASE_URL; // harsh_HSC did this 20 months ago
//export const baseUrl = APP_AUTH_BASE_URL; // my chnages based on 12th 09 stand up call

export const INTERVIEW_API_BASE_URL =
  process.env.REACT_APP_INTERVIEW_API_BASE_URL || baseUrl;

export const INTERVIEW_API_KEY =
  process.env.REACT_APP_INTERVIEW_API_KEY || "dev-key-change-me";

export const OAUTH = {
  CLIENT_ID: "ev-client-1",
  CLIENT_SECRET: "egov",
  GRANT_TYPE: "authorization_code",
    REDIRECT_URI: `${window.location.protocol}//${window.location.host}/oauth2/callback`,
};
